import React, { useEffect, useState } from 'react'
import FadeIn from 'react-fade-in'
export default function TagsCollection({ tags, onClick, noPadBottom, noPad }) {
    return (
        <FadeIn className={`popTagsContainer ${noPadBottom ? "noPadBottom" : (noPad ? "noPad" : "")}`} style={{ gap: 10, flexWrap: "wrap" }}>
            {tags.map((tag, idx) => {
                return (
                    <div onClick={() => onClick ? onClick(idx) : void 0} className='tag' key={idx}>
                        {tag}
                    </div>
                )
            })}
        </FadeIn>
    )
}
